import { FC } from 'react'
import { CieloMerchant } from '../../../core/_models'

type Props = {
    cieloMerchant: CieloMerchant
}

const ActiveCell: FC<Props> = ({ cieloMerchant }) => (
    <span className={`badge badge-light-${cieloMerchant.active ? 'success' : 'danger'}`}>
        {cieloMerchant.active ? 'Ativo' : 'Inativo'}
    </span>
)

export { ActiveCell }
